import type { FC } from 'react';

import IconLogout from '@/assets/Icons/IconLogout';
import { useAuth } from '@/context/auth';
import { useMessages } from '@/hooks/messages';

import { messages } from '../Sidebar/messages';

const LogoutButton: FC = () => {
  const { logout } = useAuth();
  const sidebarMessages = useMessages(messages);

  const handleLogout = () => {
    logout();
  };

  return (
    <button
      type='button'
      onClick={handleLogout}
      className='text-danger flex w-full items-center !py-3'
      data-testid='sign-out-button'
    >
      <IconLogout className='mr-2 h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2' />
      {sidebarMessages.signOut()}
    </button>
  );
};

export default LogoutButton;
